// Persisted identities: never renumber or reuse, even if a guide is removed.
export const feedbackIds = Object.freeze({
  tomat:1,perets:2,ogurets:3,kapusta:4,morkov:5,svekla:6,redis:7,tykva:8,kabachok:9,kukuruza:10,
  lavanda:11,'keyl-(kale)':12,beresklet:13,kartofel:14,luk:15,chesnok:16,baklazhan:17,gorokh:18,fasol:19,
  ukrop:20,petrushka:21,salat:22,bazilik:23,'zemlyanika-i-klubnika':24,malina:25,smorodina:26,kryzhovnik:27,
  yablonya:28,grusha:29,vishnya:30,'tykva-gigantskaya':31,golubika:32
});
export function feedbackEntity(slug) {
  if (!Object.hasOwn(feedbackIds,slug)) throw new Error('Unknown guide feedback identity');
  return {entity_id:feedbackIds[slug],entity_type:'Guide'};
}
export const feedbackKinds = ['Исправление', 'Дополнение', 'Идея', 'Видео'];
export function feedbackVideo(text) {
  const match=String(text || '').match(/\nВидео: (https?:\/\/\S+)$/);
  if (!match) return null;
  try {
    const url=new URL(match[1]);
    return !url.username && !url.password ? url.href : null;
  } catch { return null; }
}
export function feedbackText({kind, phase, text, video}) {
  if (!feedbackKinds.includes(kind)) throw new Error('Выберите тип предложения.');
  const message = String(text || '').trim();
  if (!message || message.length > 5000) throw new Error('Напишите предложение: от 1 до 5000 знаков.');
  let link = '';
  if (kind === 'Видео') {
    try {
      const url = new URL(String(video || '').trim());
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.href.length > 2000) throw new Error();
      link = `\nВидео: ${url.href}`;
    } catch { throw new Error('Добавьте ссылку на видео, начинающуюся с https:// или http://.'); }
  }
  return `${kind} · ${phase || 'Всё руководство'}\n\n${message}${link}`;
}
export const feedbackQuery = `
query GuideFeedback($id: bigint!, $type: String!, $limit: Int!) {
  uogorod_comments(where: {entity_type: {_eq: $type}, entity_id: {_eq: $id}}, order_by: [{created_at: asc}, {id: asc}], limit: $limit) {
    id text parent_id created_at
    author { id name nickname }
    is_liked(args: {entity: "Comment"})
    likes_aggregate(where: {entity_type: {_eq: "Comment"}}) { aggregate { count } }
  }
  uogorod_comments_aggregate(where: {entity_type: {_eq: $type}, entity_id: {_eq: $id}}) { aggregate { count } }
}`;
